<template>
  <div class="Layout">
    <!-- <div class="Layout_heder">
      <div class="heder_item">
        <headers/>
      </div>
    </div>-->
    <div class="mian_box">
      <div class="mian_list">
        <router-view/>
      </div>
    </div>
    <!-- <div class="_footer">
      <div class="img_foot">
        <img src="../../../assets/img/btmlogo.png" style="height:90%" alt>
      </div>
      <ul class="_footer_ul">
        <li class="_footer_li col">1996 - 2022 中国科学院计算机网络信息中心</li>
        <li class="_footer_li">版权所有 京ICP备05002857号-1 京公网安备11010802030922号</li>
      </ul>
    </div>-->
  </div>
</template>

<script>
import Vuescroll from "vuescroll";
import Headers from "../Headers";
export default {
  name: "Layout",
  components: {
    headers: Headers,
    vuescroll: Vuescroll
  },
  data() {
    return {};
  }
};
</script>

<style lang="less">
.Layout {
  .Layout_heder {
    height: 50px;
    border-bottom: 1px solid #7191aa;
    .heder_item {
      height: 100%;
      padding: 0 20px;
    }
  }
  ._footer {
    height: 100px;
    border-top: 3px solid #7191aa;
    display: flex;
    justify-content: center;
    align-items: center;
    .img_foot {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #808080;
      padding-right: 60px;
      margin-right: 60px;
    }
    ._footer_ul {
      line-height: 25px;
      ._footer_li {
        color: #808080;
      }
      .col {
        color: #25a4bb;
      }
    }
  }
  .mian_box {
    height: 100%;
    padding: 20px 0;
    // overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: #2c3140;
  }
  .mian_list {
    // width: 85%;
    min-width: 650px;
    margin: auto;
    border: 2px solid #008de7;
    border-radius: 5px;
    background: #ffffff;
    padding: 0 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Layout/index.vue